// extracted by mini-css-extract-plugin
module.exports = {"image":"chateau-margaux-module--image--2ElmT","imageRow":"chateau-margaux-module--imageRow--2cv4p"};